import {GeneratedRound} from 'packages/common-types/base-types';
import {Competitor} from 'packages/common-types/schema-types';

let roundWorker: Worker | undefined;

type WorkerParams = {
  modalityGame: string;
  tables: Competitor[];
  currentRound: number;
  hasFinal: boolean;
  numberOfRounds: number;
  restriccion: boolean;
};

export function runWorker({
  modalityGame,
  tables,
  currentRound,
  hasFinal,
  numberOfRounds,
  restriccion,
}: WorkerParams): Promise<GeneratedRound> {
  return new Promise((resolve, reject) => {
    if (roundWorker) {
      roundWorker.postMessage({
        modalityGame,
        tables,
        currentRound,
        hasFinal,
        numberOfRounds,
        restriccion,
      });
      roundWorker.onerror = (errEvt) => reject(errEvt);
      roundWorker.onmessage = (e) => {
        const response = e.data as GeneratedRound;
        resolve(response);
      };
    } else {
      reject(new Error('Unknow error in the worker, please try again!'));
    }
  });
}

export function initializeWorker() {
  roundWorker = new Worker('new-round.worker.js');
}

export function terminateWorker() {
  if (roundWorker) {
    roundWorker.terminate();
    roundWorker = undefined;
  }
}
